<template>
	<div class="pageBox">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/mobile/seeBg.jpg" />
		<div class="mainArea ">
			<div class="threeGod2 wow bounceInUp">
				<div class="itemBox" @click="goto(20260316)">
					<img class="itemBox_bimg" src="../../assets/20260316/1.jpg"  />
					<div class="title">ATEEZ「LIGHT THE WAY」沉浸式特展，解锁全新粉丝体验</div>
				</div>
				<div class="itemBox" @click="goto(20260122)">
					<img class="itemBox_bimg" src="../../assets/seeList/20260122.jpg"  />
					<div class="title">橙猩 VR×AMAZE 重磅联动！TXT 沉浸式VR体验特展全国燃启</div>
				</div>
				<div class="itemBox" @click="goto(20251226)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251226.jpg"  />
					<div class="title">打造文化新质生产力样本：虚拟现实电影《木兰2125》首映式暨专家座谈会在上海国际传媒港举行</div>
				</div>
				<div class="itemBox" @click="goto(20251212)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251212.jpg"  />
					<div class="title">运用优质内容和创新科技重塑娱乐消费体验：天下票仓官网全新改版，庆祝公司混改完成六周年暨新厂牌“橙猩”启动四周年</div>
				</div>
				<div class="itemBox" @click="goOut('poGDjo37p1cZVE8EdNHC6g')">
					<img class="itemBox_bimg" src="../../assets/seeList/20251204.jpg"  />
					<div class="title">Dreamcatcher VR演唱会登陆橙猩VR影院，沉浸式解锁偶像舞台！</div>
				</div>
				<div class="itemBox" @click="goto(20251113)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251113.jpg"  />
					<div class="title">橙猩 VR × 博纳电影院线完成战略签约，以 VR 之力重构影院价值</div>
				</div>
				<div class="itemBox" @click="goto(20251104)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251104.jpg"  />
					<div class="title">橙猩 VR × 大麦：试映交流会成功举行，沉浸式娱乐新场景引期待</div>
				</div>
				<div class="itemBox" @click="goto(20251028)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251028.jpg"  />
					<div class="title">橙猩 VR× 卢米埃：双方协同破局，重塑影院沉浸式体验产业格局</div>
				</div>
				<div class="itemBox" @click="goto(20251014)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251014.jpg"  />
					<div class="title">影院VR的生态阳谋：天下票仓如何从“卖票”到“组局”，定义LBE下半场的坪效革命与行业新基建</div>
				</div>
				<div class="itemBox" @click="goto(20251009)">
					<img class="itemBox_bimg" src="../../assets/seeList/20251009.jpg"  />
					<div class="title">VR体验 | 如何点燃体验经济的“感官革命”</div>
				</div>
				<div class="itemBox" @click="goto(20250824)">
					<img class="itemBox_bimg" src="../../assets/seeList/20250824.jpg"  />
					<div class="title">中国首部3A级VR沉浸式电影《木兰2125》媒体看片会圆满举办</div>
				</div>
				<div class="itemBox" @click="goto(20250725)">
					<img class="itemBox_bimg" src="../../assets/seeList/20250725.jpg"  />
					<div class="title">VR演唱会 | 科技重构娱乐产业新生态</div>
				</div>
				<div class="itemBox" @click="goto(20250704)">
					<img class="itemBox_bimg" src="../../assets/seeList/20250704.jpg"  />
					<div class="title">车银优 VR 演唱会|上海场惊喜即将来袭</div>
				</div>
				<div class="itemBox" @click="goto(20250702)">
					<img class="itemBox_bimg" src="../../assets/seeList/20250702.jpg"  />
					<div class="title">橙猩180°VR受邀参加2025江南电影大会</div>
				</div>
				<div class="itemBox" @click="goto(20250626)">
					<img class="itemBox_bimg" src="../../assets/seeList/20250626.jpg"  />
					<div class="title">VR沉浸式|变革浪潮下的创新实践与未来图景</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'See',
		data() {
			return {
				mheight:'',
				menuShow:true
			}
		},
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(!isM){
				this.$router.push({ path: '/pc/see'});
			}
		},
		mounted() {
			if(window.innerWidth<=800){
				this.menuShow=false
			}
			const divWidth = this.$refs.itemBox_bref.offsetWidth;
			this.mheight=410*divWidth/570+'px'
			this.$nextTick(() => {
				
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		},		
		methods:{
			goto(type){
				this.$router.push({ path: '/mobile/seeInfo?type='+type});
			},
			goOut(id){
				window.location.href='https://mp.weixin.qq.com/s/'+id
			}
		}
	}
</script>
<style lang="less" scoped>
	.pageBox{
		background: #000;
	}
	.threeGod {
		margin: 50px auto;
		width: 1000px;
		color: #fff;
		font-size: 20px;
		font-weight: bold;
		img {
			margin-bottom: 20px;
		}
	}
	.itemBox_bimg{
		width: 100%;
		height: auto;
	}
	.lightBox{
		position: relative;
		overflow: hidden;
		padding-bottom: 80px;
	}
	.light-1 {
		position: absolute;
		z-index: 0;
		width: 1000px;
		height: 1000px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 10s linear infinite;
		background: rgba(106, 0, 255, 0.4);
		top: 10px;
		left: calc(50% - 500px);
		animation-delay: 0s;
	}
	.itemBox{
		background: #fff;
		margin-bottom: 50px;
		text-align: left;
		overflow: hidden;
		border-radius: 2px;
		img{
			margin-top: -6px;
		}
		.title{
			color: #000;
			font-size: 16px;
			padding:10px;
			line-height: 30px;
		}
	}
	.threeGod2 {
		position: relative;
		padding-top: 30px;
		padding-bottom: 50px;
	}
</style>